module.exports = __webpack_public_path__ + "media/images/my_apps/feature_icons/icon_heart-35a63f951a55ef5b9f5ae255d2b672c9.svg";